module.exports = __webpack_public_path__ + "static/media/shiftshave-2.982432c7.jpg";